import React from 'react';

import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import AgentPanel from '../AgentPanel';
import AppTopBar from './AppTopBar';
import WorkflowStepper from './WorkflowStepper';
import WorkflowToolbar from './WorkflowToolbar';
import { WorkflowChromeProvider } from './WorkflowChromeContext';

import { Container, Content, Wrapper } from './style';

const Layout = () => {
  return (
    <WorkflowChromeProvider>
      <Container>
        <Wrapper>
          <AppTopBar />
          <WorkflowStepper />
          <WorkflowToolbar />
          <Content open={false}>
            <Outlet />
          </Content>
          <div className="clearer"></div>
        </Wrapper>
        <AgentPanel />
      </Container>
    </WorkflowChromeProvider>
  );
};

export default observer(Layout);
